var map = {
	"./accept.mp3": "e0ac",
	"./award.mp3": "c28b",
	"./click.mp3": "c94c",
	"./completion.mp3": "9fa3",
	"./correct.mp3": "6103",
	"./count.mp3": "e7cb",
	"./snap.mp3": "0ffa",
	"./success.mp3": "ee41",
	"./unlock.mp3": "3dc0",
	"./whoosh.mp3": "e64a",
	"./wrong.mp3": "6740"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1aa9";